import { defineMessages } from "react-intl";

export default defineMessages({
  doYouHaveAQuestion: {
    id: "contractAcceptanceFAQSection.doYouHaveAQuestion",
    defaultMessage: "Do you have a question?",
  },
  whatIsTheRingTwicePlusFormula: {
    id: "fAQSection.whatIsTheRingTwicePlusFormula",
    defaultMessage: "What is the Ring Twice+ formula?",
  },
  whatIsTheRingTwicePlusFormulaAnswer: {
    id: "fAQSection.whatIsTheRingTwicePlusFormulaAnswer",
    defaultMessage:
      "The Ring Twice+ plan allows you to use the services of providers in your neighborhood without paying management fees on each service, in more than 120 categories. It gives you access to telephone customer support as well as exclusive Ring Twice+ benefits.",
  },
  whatDoesTheStandardFormulaConsistOf: {
    id: "fAQSection.whatDoesTheStandardFormulaConsistOf",
    defaultMessage: "What does the Standard formula consist of?",
  },
  whatDoesTheStandardFormulaConsistOfAnswer: {
    id: "fAQSection.whatDoesTheStandardFormulaConsistOfAnswer",
    defaultMessage:
      "The Standard plan allows you to occasionally call on a service provider and therefore discover Ring Twice services. By taking this formula, 20% management fees will be added to each service performed.",
  },
  whyIsRingTwicePaid: {
    id: "fAQSection.whyIsRingTwicePaid",
    defaultMessage: "Why is Ring Twice paid?",
  },
  whyIsRingTwicePaidAnswer: {
    id: "fAQSection.whyIsRingTwicePaidAnswer",
    defaultMessage:
      "Ring Twice selects and supports thousands of providers to guarantee the quality of services. We strive to constantly improve our platform and provide the best customer support. Ring Twice allows you to obtain services in a legal framework, with secure payments and insurance coverage for providers.",
  },
  isThePriceOfThePackageIncludedInMyServiceProviderOffer: {
    id: "fAQSection.isThePriceOfThePackageIncludedInMyServiceProviderOffer",
    defaultMessage:
      "Is the price of the package included in my service provider's offer?",
  },
  isThePriceOfThePackageIncludedInMyServiceProviderOfferAnswer: {
    id: "fAQSection.isThePriceOfThePackageIncludedInMyServiceProviderOfferAnswer",
    defaultMessage:
      "The price of the package is not included in your service provider's offer. With the Standard plan, you will have to pay 20% more when paying for the service (at the end of the service). With the Ring Twice+ plan, you only pay for the plan before selecting the service provider. There are no other costs when paying your service provider.",
  },
  isThePriceOfThePackageIncludedInMyServiceProviderOfferAnswerActivationRate: {
    id: "fAQSection.isThePriceOfThePackageIncludedInMyServiceProviderOfferAnswerActivationRate",
    defaultMessage:
      "The price of the subscription is <bold>not</bold> included in your service provider's offer, it is a subscription available in Quarterly or Yearly periods which can be acquired separately. The subscription saves 20% on all the demands you will do on Ring Twice.",
  },
  howDoIChooseTheFormulaINeed: {
    id: "fAQSection.howDoIChooseTheFormulaINeed",
    defaultMessage: "How do I choose the formula I need?",
  },
  howDoIChooseTheFormulaINeedAnswer: {
    id: "fAQSection.howDoIChooseTheFormulaINeedAnswer",
    defaultMessage:
      "Don’t hesitate to choose the formula that best suits your needs! Do you have recurring needs with the same service provider or do you want to use different service providers? Adopt the Ring Twice+ formula! Conversely, if it is a one-off service, choose the Standard plan and pay management fees per service.",
  },

  howToPayForTheService: {
    id: "fAQSection.howToPayForTheService",
    defaultMessage: "How to pay for the service?",
  },
  howToPayForTheServiceAnswer: {
    id: "fAQSection.howToPayForTheServiceAnswer",
    defaultMessage:
      "You can pay for the service performed by credit card, Bancontact or bank transfer.",
  },
  willIReceiveAnInvoice: {
    id: "fAQSection.willIReceiveAnInvoice",
    defaultMessage: "Will I receive an invoice?",
  },
  willIReceiveAnInvoiceAnswer: {
    id: "fAQSection.willIReceiveAnInvoiceAnswer",
    defaultMessage:
      "Receipts and invoices for services rendered: A receipt will be issued for each service provided. Only if the service provider is an independent service provider (blue badge Pro), you will also receive an [invoice](https://listminut.zendesk.com/hc/nl/articles/7844076492700-Kan-ik-een-factuur-krijgen-) for the service provided. Invoices for your Ring Twice+ plan: An invoice is available for your Ring Twice plan via the My Ring Twice+ plan tab.",
  },
  whatIfIDoNotAgreeWithTheRequestedAmount: {
    id: "fAQSection.whatIfIDoNotAgreeWithTheRequestedAmount",
    defaultMessage: "What if I do not agree with the requested amount?",
  },
  whatIfIDoNotAgreeWithTheRequestedAmountAnswer: {
    id: "fAQSection.whatIfIDoNotAgreeWithTheRequestedAmountAnswer",
    defaultMessage:
      "Do you disagree with the requested amount? Then you can refute the payment. Then contact the service provider to discuss the situation and look for a solution together. If the problem persists or if you need help, you can also contact us.",
  },
  whyPayManagementFeesToRingTwice: {
    id: "fAQSection.whyPayManagementFeesToRingTwice",
    defaultMessage: "Why pay management fees to Ring Twice?",
  },
  whyPayManagementFeesToRingTwiceAnswer: {
    id: "fAQSection.whyPayManagementFeesToRingTwiceAnswer",
    defaultMessage: "How can I work with this service provider again?",
  },
  howCanIWorkWithThisServiceProviderAgain: {
    id: "fAQSection.howCanIWorkWithThisServiceProviderAgain",
    defaultMessage: "How can I work with this service provider again?",
  },
  howCanIWorkWithThisServiceProviderAgainAnswer: {
    id: "fAQSection.howCanIWorkWithThisServiceProviderAgainAnswer",
    defaultMessage:
      'All the service providers you have worked with can always be found via your address book on your account. You click on the tab "[My address book](https://ringtwice.be/fr/address_book)" - And then click on the button "Apply to".',
  },
  whatDoesRingTwicePlusEntail: {
    id: "fAQSection.whatDoesRingTwicePlusEntail",
    defaultMessage: "What does Ring Twice+ entail?",
  },
  whatDoesRingTwicePlusEntailAnswer: {
    id: "fAQSection.whatDoesRingTwicePlusEntailAnswer",
    defaultMessage:
      "With Ring Twice+ you can call on the talents of service providers in your area, from more than 120 different categories, without paying management costs per service. It gives you access to telephone customer support and exclusive Ring Twice+ benefits.",
  },
  howToStopRenewal: {
    id: "fAQSection.howToStopRenewal",
    defaultMessage: "How to stop subscription renewal ?",
  },
  howToStopRenewalAnswer: {
    id: "fAQSection.howToStopRenewalAnswer",
    defaultMessage:
      "To cancel the automatic renewal, simply go to your Ring Twice account and deactivate the plan. There are no cancellation fees. You can use your plan until its expiration date. After that, you can reactivate the plan of your choice.",
  },
  howToChangeSubscription: {
    id: "fAQSection.howToChangeSubscription",
    defaultMessage: "Can I change my plan along the way ?",
  },
  howToChangeSubscriptionAnswer: {
    id: "fAQSection.howToChangeSubscriptionAnswer",
    defaultMessage:
      "If you have a Ring Twice+ plan: You can cancel the automatic renewal or change the type of Ring Twice+ plan. If you have a Standard plan: We will ask you to choose between the two plans for each new service. You can therefore easily switch to the Ring Twice+ plan if you wish.",
  },
  whatAreTheAvailablePaymentMethods: {
    id: "fAQSection.whatAreTheAvailablePaymentMethods",
    defaultMessage: "What are the avalaible payment methods ?",
  },
  whatAreTheAvailablePaymentMethodsAnswer: {
    id: "fAQSection.whatAreTheAvailablePaymentMethodsAnswer",
    defaultMessage:
      "The monthly and quarterly plans can only be paid by credit card (Visa, Mastercard, or American Express). The annual plan can be paid by credit card, Bancontact, or bank transfer.",
  },
  canIBeReimbursed: {
    id: "fAQSection.canIBeReimbursed",
    defaultMessage: "If the service is cancelled, can I be reimbursed ? ",
  },
  canIBeReimbursedAnswer: {
    id: "fAQSection.canIBeReimbursedAnswer",
    defaultMessage:
      "Subscribing to a plan gives you unlimited access to our community of service providers. If a service does not take place, we will always look for a solution to ensure you are assisted. You can request a refund of your subscription when the service provider is responsible for the service not being carried out.",
  },
  howAndWhenToPayService: {
    id: "fAQSection.howAndWhenToPayService",
    defaultMessage: "How and when to pay the service ?",
  },
  howAndWhenToPayServiceAnswer: {
    id: "fAQSection.howAndWhenToPayServiceAnswer",
    defaultMessage:
      "We ask you to pay for your Ring Twice+ plan now. Once the service is completed, you will need to pay the provider through the platform (by credit card, Bancontact, or bank transfer). We will send you an email at that time with the payment details.",
  },
  canIPayCash: {
    id: "fAQSection.canIPayCash",
    defaultMessage: "Can I pay cash ?",
  },
  canIPayCashAnswer: {
    id: "fAQSection.canIPayCashAnswer",
    defaultMessage:
      "It is not possible to pay for a service in cash or to pay the provider directly (by transfer or other means). All financial transactions must always take place on Ring Twice so that we can support each provider and ensure the quality and legality of the service.",
  },
  whyPayFeesToRingTwice: {
    id: "fAQSection.whyPayFeesToRingTwice",
    defaultMessage: "Why do we pay fees to Ringtwice ?",
  },
  whyPayFeesToRingTwiceAnswer: {
    id: "fAQSection.whyPayFeesToRingTwiceAnswer",
    defaultMessage:
      "The management fees are Ring Twice's way of earning income, but not only that 😉. They cover, on one hand, the operational costs of our platform such as customer support and secure payments. On the other hand, they allow us to provide a legal framework and insurance coverage for the service providers.",
  },
  howToChooseServiceProviderForMyTask: {
    id: "fAQSection.howToChooseServiceProviderForMyTask",
    defaultMessage: "How do I select a service provider for my task ?",
  },
  howToChooseServiceProviderForMyTaskAnswer: {
    id: "fAQSection.howToChooseServiceProviderForMyTaskAnswer",
    defaultMessage:
      "Have you made your choice among the received applications? You now need to select your Service Provider in order to exchange contact details. Click on the Select (first name) or View offer button. If you do not yet have an active plan, choose one of the two Ring Twice plans (Standard or Ring Twice+). You now have your service provider's contact details. Feel free to (re)confirm the appointment via the Ring Twice messaging system or by phone/email. Please note that your service provider must have applied for you to be able to select their application. This means they must have submitted their price offer on Ring Twice.",
  },
  howToAddPicturesToMyTask: {
    id: "fAQSection.howToAddPicturesToMyTask",
    defaultMessage: "How do I add pictures to my task ?",
  },
  howToAddPicturesToMyTaskAnswer: {
    id: "fAQSection.howToAddPicturesToMyTaskAnswer",
    defaultMessage:
      "Having a detailed request allows you to receive more suitable offers. We recommend adding photos to your request to give a preview of the work 😉. Add your photos when creating your service request. Add your photos by editing your request. Click on “Edit my request” or the small pencil icon. You can add up to 3 photos per request. They must be in .jpg format (be mindful of the file size). Videos cannot be uploaded.",
  },
  howToDiscussWithServiceProviderThatReacted: {
    id: "fAQSection.howToDiscussWithServiceProviderThatReacted",
    defaultMessage:
      "How to chat with service providers who responded to my request ?",
  },
  howToDiscussWithServiceProviderThatReactedAnswer: {
    id: "fAQSection.howToDiscussWithServiceProviderThatReactedAnswer",
    defaultMessage:
      "Once you start receiving responses to your request, you can chat with the different candidates. Using the chat tool, you can send messages to ask questions or get more information about them, their experience, and their offer. Important: Until you select a service provider’s application, you cannot exchange contact details or personal information (last name, email, address, social media, meeting location, etc.). To select a candidate (for the job or a first visit), click the green “Select (provider’s first name)” or “View offer” button. Until you select a service provider, your conversation remains public.",
  },
  howToModifyMyRequest: {
    id: "fAQSection.howToModifyMyRequest",
    defaultMessage: "How to edit my request ?",
  },
  howToModifyMyRequestAnswer: {
    id: "fAQSection.howToModifyMyRequestAnswer",
    defaultMessage:
      "Need to edit or adjust your request? No worries! You can modify your service requests as long as they haven’t been assigned. To do this, simply go to your request and click on the small pencil icon or Edit my request.",
  },
  whenDoesAServiceStartAndEnd: {
    id: "fAQSection.whenDoesAServiceStartAndEnd",
    defaultMessage: "When does a service start and end ?",
  },
  whenDoesAServiceStartAndEndAnswer: {
    id: "fAQSection.whenDoesAServiceStartAndEndAnswer",
    defaultMessage:
      "The service provider should start counting their hours upon arrival at the service location. Time spent traveling to the location or shopping for materials (if under 30 minutes) is not considered service time. On Ring Twice, a started hour is a billed hour. However, service providers have the option to charge in 30-minute increments, though they are not required to do so. If a different arrangement is agreed upon in writing between the provider and the requester, that written agreement will take precedence.",
  },
  whatDoesProBadgeMean: {
    id: "fAQSection.whatDoesProBadgeMean",
    defaultMessage:
      "What does the PRO badge on my service provider’s profile mean ?",
  },
  whatDoesProBadgeMeanAnswer: {
    id: "fAQSection.whatDoesProBadgeMeanAnswer",
    defaultMessage:
      "On Ring Twice, there are two types of service providers: individuals and PROs. PROs are independent professionals. What’s the Difference Between PROs and Individuals?Individuals operate within the collaborative economy: services provided by individuals, for individuals. Independent professionals (PROs) are registered with their business details on our platform. You will receive an invoice for the services they provide.",
  },
});
